import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import CargaDatosArchivo from './CargaDatosArchivo';
import FuelPricesAdminPanel from './FuelPricesAdminPanel';
import VehicleRestrictionAdminPanel from './VehicleRestrictionAdminPanel';
import PeajesAdminPanel from './PeajesAdminPanel';
import AdminConsejosTemporada from './AdminConsejosTemporada';
import AdminNoticiasTransito from './AdminNoticiasTransito';
import AdminAlertasTemporada from './AdminAlertasTemporada';

const ITEMS = [
  { to: '/admin/categorias',       label: 'Categorías',           icon: '📁', description: 'Gestionar categorías del catálogo' },
  { to: '/admin/rubros',           label: 'Rubros',               icon: '📂', description: 'Gestionar rubros de empresas' },
  { to: '/admin/marcas',           label: 'Marcas',               icon: '🏷️', description: 'Gestionar marcas de vehículos' },
  { to: '/admin/tipos-empresa',    label: 'Tipos de empresa',     icon: '🏢', description: 'Gestionar tipos de empresa' },
  { to: '/admin/servicios-admin',  label: 'Servicios',            icon: '🔧', description: 'Gestionar servicios ofrecidos' },
  { to: '/admin/moderacion-reseñas', label: 'Reseñas',            icon: '⭐', description: 'Moderar reseñas de clientes' },
  { to: '/admin/avatares-biblioteca', label: 'Avatares precargados', icon: '🎨', description: 'Generar y gestionar avatares de modelos para la biblioteca' },
];

const TABS = [
  { id: 'uploads',              label: 'Carga de archivos' },
  { id: 'fuel-prices',          label: 'Precios combustible' },
  { id: 'vehicle-restrictions', label: 'Restricción vehicular' },
  { id: 'peajes',               label: 'Peajes Chile' },
  { id: 'consejos-temporada',   label: '🌤 Consejos temporada' },
  { id: 'noticias-transito',    label: '🚦 Noticias de tránsito' },
  { id: 'alertas-temporada',    label: '⚠️ Alertas de temporada' },
];

export default function GestionContenidoAdmin() {
  const [activeTab, setActiveTab] = useState('uploads');

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Gestión de contenido</h1>
        <p className="mt-1 text-slate-600">
          Administra categorías, rubros, marcas, tipos de empresa, servicios y reseñas del catálogo.
        </p>
      </div>

      {/* Navigation cards */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="group flex items-start gap-4 rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition-all hover:border-slate-300 hover:shadow-md"
          >
            <span className="text-3xl text-slate-400 group-hover:text-slate-600" aria-hidden>{item.icon}</span>
            <div className="min-w-0 flex-1">
              <h2 className="font-semibold text-slate-900 group-hover:text-blue-700">{item.label}</h2>
              <p className="mt-0.5 text-sm text-slate-500">{item.description}</p>
              <span className="mt-2 inline-block text-sm font-medium text-blue-600 group-hover:underline">Ir →</span>
            </div>
          </Link>
        ))}
      </div>

      {/* Tab bar */}
      <div className="border-b border-slate-200">
        <nav className="-mb-px flex gap-1" aria-label="Pestañas de contenido">
          {TABS.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`whitespace-nowrap rounded-t-lg border border-b-0 px-5 py-2.5 text-sm font-semibold transition-colors ${
                activeTab === tab.id
                  ? 'border-slate-200 bg-white text-blue-700'
                  : 'border-transparent bg-slate-100 text-slate-500 hover:bg-slate-200 hover:text-slate-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab content */}
      <div className="min-h-[320px]">
        {activeTab === 'uploads' && <CargaDatosArchivo />}
        {activeTab === 'fuel-prices' && <FuelPricesAdminPanel />}
        {activeTab === 'vehicle-restrictions' && <VehicleRestrictionAdminPanel />}
        {activeTab === 'peajes' && <PeajesAdminPanel />}
        {activeTab === 'consejos-temporada' && <AdminConsejosTemporada />}
        {activeTab === 'noticias-transito' && <AdminNoticiasTransito />}
        {activeTab === 'alertas-temporada' && <AdminAlertasTemporada />}
      </div>
    </div>
  );
}
